<script setup>
defineProps({
  startIcon: {
    type: String,
    default: null,
  },
  variant: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <div class="offer-tile-tag-wrapper">
    <div :class="`offer-tile-tag offer-tile-tag--${variant}`">
      <div
        v-if="startIcon"
        class="offer-tile-tag__icon-wrapper"
      >
        <span :class="`offer-tile-tag__icon--${startIcon}`" />
      </div>

      <span>
        <slot />
      </span>
    </div>
  </div>
</template>
